import React from 'react';

const AppPreloader = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-950 flex items-center justify-center z-50">
      <style>
        {`
          @keyframes float {
            0%, 100% {
              transform: translateY(0px) scale(1);
            }
            50% {
              transform: translateY(-20px) scale(1.05);
            }
          }
          
          @keyframes pulse-glow {
            0%, 100% {
              opacity: 0.6;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.1);
            }
          }
          
          .logo-float {
            animation: float 2s ease-in-out infinite;
          }
          
          .logo-glow {
            animation: pulse-glow 2s ease-in-out infinite;
          }
        `}
      </style>
      
      <div className="relative">
        {/* Glow effect */}
        <div 
          className="absolute inset-0 logo-glow"
          style={{
            background: 'radial-gradient(circle, rgba(99, 102, 241, 0.4) 0%, transparent 70%)',
            filter: 'blur(30px)',
            width: '200px',
            height: '200px',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        />
        
        {/* Logo */}
        <img
          src={`${process.env.PUBLIC_URL}/logo192.png`}
          alt="Vitria"
          className="logo-float relative z-10"
          style={{
            width: '120px',
            height: '120px',
            filter: 'drop-shadow(0 0 20px rgba(99, 102, 241, 0.5))'
          }}
        />
      </div>
    </div>
  );
};

export default AppPreloader;
